import './attachment.directive.ajs.css';

import { isArray } from 'angular';

import templateUrl from './attachment.directive.html';

export let AttachmentDirective = [
  '$window',
  $window => ({
    restrict: 'E',
    require: 'ngModel',
    transclude: false,
    scope: {
      ngModel: '=',
      readOnly: '@?',
      hoverable: '@?',
      removeLinkCallback: '&?',
    },
    link: (scope, elem, attrs) => {
      scope.$watch('ngModel', data => {
        scope.ngModel = isArray(data) ? data : [];
      });
      scope.readOnly = scope.$eval(attrs.readOnly) || false;
      scope.visibleAttachment = false;
      scope.show = () => {
        if (scope.readOnly) return;
        scope.visibleAttachment = !scope.visibleAttachment;
      };
      scope.hover = visible => {
        if (scope.readOnly) return;
        scope.visibleAttachment = visible;
      };
      scope.download = file => {
        if (scope.readOnly) return;
        if (file && file.source) {
          $window.open(file.source, '_blank');
        }
      };

      let $item = $(elem);
      let $popup = $('.attachment_wrapper .attachment_popup', $item);
      $item.click(e => {
        e.preventDefault();
        e.stopPropagation();
      });
      $popup.click(e => {
        e.preventDefault();
        e.stopPropagation();
      });

      // fix to prevent memory leak
      scope.$on('$destroy', () => {
        // remove listener
        $item.off('click');
        $popup.off('click');
      });
      elem.on('$destroy', () => {
        scope.$destroy();
      });

      scope.doRemoveLinkCallback = file => {
        if (scope.removeLinkCallback) {
          scope.removeLinkCallback({ $event: { file } });
        }
      };

      // convert the size in parameter into human readable string
      let sizeToStr = bytes => {
        if (bytes === 0) {
          return '0.00 o';
        }
        let e = Math.floor(Math.log(bytes) / Math.log(1024));
        // RTFM : 1024 -- > '1 Ko'   , 1024000 --> '1 Mo'
        return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'o';
      };

      scope.formatSize = _elem => {
        let _ret = '';
        if (_elem.file && _elem.file.size) {
          return (_elem.filename ?? _elem.title) + ' - ' + sizeToStr(_elem.file.size);
        } else if (_elem.filename && _elem.sizeInFrame) {
          return `${_elem.filename} - ${_elem.sizeInFrame}`;
        } else if (_elem.sizeInFrame) {
          _ret = ' - ' + _elem.sizeInFrame;
        }
        return _elem.title + _ret;
      };
    },
    templateUrl,
  }),
];

export default 'attachment';
